import { useCallback, useState } from 'react';

export const useToggle = (defaultIsOpen = false) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const toggle = useCallback(() => setIsOpen((isOpen) => !isOpen), []);

  return [isOpen, toggle] as const;
};
